import { useEffect, useState } from 'react';

export default function FoodWasteCounter() {
  const [counter, setCounter] = useState(1002123380);

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter((prev) => prev + Math.floor(Math.random() * 10) + 1);
    }, 100);

    return () => clearInterval(interval);
  }, []);

  const formatNumber = (num: number) => {
    return num.toLocaleString('en-US');
  };

  return (
    <section className="relative py-32 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-emerald-500 to-teal-700 overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 text-white">
          <svg
            width="100"
            height="100"
            viewBox="0 0 100 100"
            fill="currentColor"
          >
            <circle cx="50" cy="50" r="40" />
          </svg>
        </div>
        <div className="absolute bottom-20 right-20 text-white">
          <svg
            width="150"
            height="150"
            viewBox="0 0 100 100"
            fill="currentColor"
          >
            <path d="M50 10 L90 90 L10 90 Z" />
          </svg>
        </div>
      </div>

      {/* Content */}
      <div className="relative max-w-5xl mx-auto text-center">
        <div className="space-y-6">
          <p className="text-teal-100 text-sm font-bold uppercase tracking-widest mb-4">
            Global Food Waste
          </p>
          <h2 className="text-5xl sm:text-6xl lg:text-8xl font-bold text-white tracking-tight tabular-nums transition-all duration-300">
            {formatNumber(counter)}
          </h2>

          <p className="text-2xl sm:text-3xl lg:text-4xl text-white/90 font-light leading-relaxed">
            Tonnes of food wasted
          </p>

          <p className="text-lg sm:text-xl text-teal-100 font-medium">
            Every rescued meal through Smartly Orders brings us one step closer
            to reducing this number.
          </p>
        </div>
      </div>
    </section>
  );
}
